import paging from './paging/index'

export default [
    paging
]